import React, { cloneElement } from "react";
import { reduce } from "lodash";

export default function intersperse<T extends React.ReactElement>(
  arr: T[],
  separator: (n: number) => T
) {
  return reduce(
    arr,
    (acc, currentElement, currentIndex) => {
      const isLast = currentIndex === arr.length - 1;
      return [
        ...acc,
        cloneElement(currentElement, {
          key: currentElement.props.key || "intersperse_" + currentIndex,
        }),
        ...(isLast
          ? []
          : [
              cloneElement(separator(currentIndex), {
                key: "separator_" + currentIndex,
              }),
            ]),
      ];
    },
    []
  );
}
